import type { ReactNode } from 'react';

export interface MainContentProps {
  children: ReactNode;
}

/**
 * Slot principal — usa <section> porque o Shell já tem <main> como wrapper
 * externo (a11y exige 1 main por documento).
 *
 * [container-type:inline-size] (E24.F1.T02): a section é um container-query
 * container para que headers full-bleed (.laudo-page__header) derivem o bleed
 * horizontal da largura REAL do content-box via 100cqw, em vez de constantes
 * vw hardcoded (frágeis a zoom/rem/scrollbar).
 */
export function MainContent({ children }: MainContentProps) {
  return (
    <section
      id="main-content"
      tabIndex={-1}
      className="flex-1 overflow-y-auto bg-bg px-8 py-7 [container-type:inline-size] focus:outline-none"
    >
      <div className="mx-auto w-full max-w-shell-xl">{children}</div>
    </section>
  );
}
